<template>
    <div>
        <div class="page-top mb-1 mb-3 clearfix">
            <h1 class="float-left"> MIS Report </h1>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label class="label block-label"> From Date </label>
                    <datepicker name="from_date" v-model="from_date" input-class="datepicker" :bootstrap-styling="true" placeholder="From Date"></datepicker>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label class="label block-label"> To Date </label>
                    <datepicker name="to_date" v-model="to_date" input-class="datepicker" :bootstrap-styling="true" placeholder="To Date"></datepicker>
                </div>
            </div>
            <div class="col">
                <div class="form-group align-right">
                    <br>
                    <button @click="getVoucherReport(true)"  class="btn btn-primary">Submit</button>
                    <button @click="exportReport(false)"  class="btn btn-primary">Export</button>
                </div>
            </div>
        </div>
        <div class="tab-content" id="myTabContent">
            <div>



                <div class="tab-pane fade show active" id="" role="tabpanel" aria-labelledby="new-tab">
                    <table id="dt-reports" class="table" style="width:100%">
                        <thead>
                        <tr>
                            <th>Date</th>
                            <th>Total Amount</th>
                            <th>View</th>
                            <th>Download</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="report in reports" :key="report.created_at">
                            <td>Finja Fee Collection - {{report.created_at}}</td>
                            <td>{{report.invoice_amount}}</td>
                            <td><router-link :to="/viewReportDetails/+report.created_at" class="action edit"><i class="fas fa-eye"></i></router-link></td>
                            <td><a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" title="Download" class="action" @click="exportReport(report.created_at)" ><i class="fas fa-download"></i></a></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    var dtTable = null;
    export default {
        data() {
            return {
                reports : null,
                from_date:'',
                to_date:'',
                check:false,
                dtTable:null,
            };
        },
        mounted() {
            this.getVoucherReport(false);
            $('select.selectpicker').selectpicker();
        },
        methods: {
            exportReport: function(date){
                var that = this;
                that.$Progress.start();
                if(!date){
                 var formData = {
                        'from_date': moment(that.from_date).format('YYYY-MM-DD'),
                        'to_date': moment(that.to_date).format('YYYY-MM-DD'),
                    }
                     if(formData.from_date=='Invalid date' || formData.to_date=='Invalid date'){
                        that.showAlertBox('error','Please Select Dates');
                        return false
                      }
                }else{
                    var formData = {
                        'from_date': date,
                        'to_date': date,
                    }
                }
       
                axios.post('/api/reportDetailsExport', formData,{
                    responseType: 'blob'
                })
                    .then(res => {
                        if(res.status == 200){
                            const url = URL.createObjectURL(new Blob([res.data], {
                                type: 'application/vnd.ms-excel'
                            }))

                            const link = document.createElement('a')
                            link.href = url
                            link.setAttribute('download', 'misReportDetails.xls')
                            document.body.appendChild(link)
                            link.click()
                            that.$Progress.finish();
                        }else{
                            that.$Progress.fail();
                            that.showAlertBox('error','Error to load data');
                        }
                    })
                    .catch(err => {
                        that.$Progress.fail();
                        that.showAlertBox('error','Error to load data');
                    });
            },
            callDataTable: function(){
                this.dtTable = $('#dt-reports').DataTable({
                    "sDom": '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                    "searching":true,
                    columnDefs: [ {
                        orderable: false,
                    }],
                    order: [[ 0, "desc" ]],
                });
            },
            getVoucherReport: function(draw=false){
                this.$Progress.start();
                var from_date=moment(this.from_date).format('YYYY-MM-DD')
                var to_date=moment(this.to_date).format('YYYY-MM-DD')

                axios.get("/api/getMisReport?from_date="+from_date+'&to_date='+to_date)
                    .then(res => {
                          if(draw){
                           this.dtTable.destroy();
                        }
                        if(res.status == 200){
                            this.reports    = res.data.data;
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error', "Error to load data")
                        }
                      
                    })
                    .then(res => {
                        this.callDataTable();
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        console.log(err);
                        this.showAlertBox('error', "Error to load data")
                    });
            }
        },
        created() {
            //
        }
    }
</script>
